export default __webpack_public_path__ + "static/media/Failed.b81cb0e5.png";